import { render, staticRenderFns } from "./SetAutoTrade.vue?vue&type=template&id=75c8c093&scoped=true&"
import script from "./SetAutoTrade.vue?vue&type=script&lang=ts&"
export * from "./SetAutoTrade.vue?vue&type=script&lang=ts&"
import style0 from "./SetAutoTrade.vue?vue&type=style&index=0&id=75c8c093&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8c093",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
